


















import Vue from 'vue';
import AccountDeleteModal from '@/components/ModalAccountDelete.vue';
import * as AccountStore from '@/containers/account/store';

export default Vue.extend({
  components: {
    AccountDeleteModal,
  },
  data() {
    return {
      modalOpened: false,
    };
  },
  methods: {
    async onSubmit() {
      try {
        await this.$store.dispatch(AccountStore.DeleteAccount.namespaced({}));
        window.location.replace('/?notice=ご利用ありがとうございました。');
      } catch (e) {
        this.$notifyError(
          '予期せぬエラーが発生しました。管理者にお問い合わせください。'
        );
      }
    },
  },
});
